
import React from 'react'
import GenieLogo from '@/components/ui/icon/icons/GenieLogo'
import type { Workspace } from '@/components/workspace/shared/types'

interface WorkspaceHeaderProps {
  setIsSettingsOpen: (isOpen: boolean) => void
  openWorkspaceModal: () => void
  workspaces: Workspace[]
  setWorkspaces: React.Dispatch<React.SetStateAction<Workspace[]>>
}

export const WorkspaceHeader: React.FC<WorkspaceHeaderProps> = ({
  setIsSettingsOpen,
  openWorkspaceModal,
  workspaces,
  setWorkspaces,
}) => {
  return (
    <div className="flex items-center justify-start p-2">
      <GenieLogo className="h-8 w-auto" />
    </div>
  )
}
